import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  BrowserRouter as Router,
  useLocation,
} from "react-router-dom";
import FrontLayout from "./components/Front/FrontLayout";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/auth/Login";
import { PrivateRoute, PublicRoute } from "./utils/function";
import { store } from "./store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import AdminLayout from "./components/Admin/AdminLayout";
import Customers from "./pages/customers";
import Dashboard from "./pages/dashboard";
import StoreOwner from "./pages/storeOwner";
import AddStoreOwner from "./pages/storeOwner/AddStoreOwner";
import Store from "./pages/store";
import AddStore from "./pages/store/AddStore";
import Category from "./pages/category";
import Units from "./pages/units";
import { useTranslation } from "react-i18next";
import StoreFrontAdd from "./pages/store/StoreFrontAdd";
import Product from "./pages/product";
import AddProduct from "./pages/product/AddProduct";
import AdminLogin from "./pages/auth/AdminLogin";
import NoURLFoundPage from "./components/Common/NoURLFoundPage";
import SplashScreen from "./components/Common/SplashScreen";
import AdminProfile from "./pages/auth/AdminProfile";
import StoreOwnerProfile from "./pages/auth/StoreOwnerProfile";
import Signup from "./pages/auth/Signup";
import InventoryView from "./pages/customerStore/ProductCatalogueView";
import StorePOSView from "./pages/customerStore/mainPage";
import CustomerProfile from "./pages/auth/CustomerProfile";
import SuccessPage from "./pages/customerStore/SuccessPage";
import CustomerOrder from "./pages/customerOrder";
import CustomerOrderDetails from "./pages/customerOrder/CustomerOrderDetails";
import PendingOrdersList from "./pages/dashboard/pendingOrder";
import StoreOwnerOrder from "./pages/storeOrder";
import StoreOwnerOrderList from "./pages/storeOwnerOrder";
import StoreOwnerOrderDetails from "./pages/storeOwnerOrder/StoreOwnerOrderDetails";
import DailyCollection from "./pages/dailyCollection";
import { AdminProvider } from "./components/Admin/AdminContext";
import ChangePassword from "./pages/auth/ChangePassword";
import DeleteAccount from "./pages/auth/DeleteAccount";
import TermsAndConditions from "./pages/LandingPage/TermsAndConditions";
import PrivacyPolicy from "./pages/LandingPage/PrivacyPolicy";
import ForOwner from "./pages/LandingPage/ForOwner";
import ForCustomer from "./pages/LandingPage/ForCustomer";
import AboutUs from "./pages/LandingPage/AboutUs";
import ContactUs from "./pages/LandingPage/ContactUs";
import OTP from "./pages/auth/Otp";
import Wallet from "./pages/wallet";
import StoreOwnerWalletDetails from "./pages/wallet/storeOwnerWalletDetails";
import WalletStoreDetails from "./pages/customerStore/WalletStoreDetails";
import ChartProduct from "./pages/chartProduct";
import CustomerLedger from "./pages/report/CustomerLedger";
import AddVendor from "./pages/vendor/AddVendor";
import VendorList from "./pages/vendor";
import StockEntry from "./pages/stock/stockEntry";
import FavouriteProducts from "./pages/favouriteProducts";
import StoreWiseCustomer from "./pages/StoreWiseCustomer";

const App = () => {
  const { t } = useTranslation();
  const [showSplash, setShowSplash] = useState(false);

  useEffect(() => {
    document.title = t("dukaanSetu");

    const hasVisited = localStorage.getItem("hasVisited");
    const isMobile = window.innerWidth < 1024;

    if (!hasVisited && isMobile) {
      setShowSplash(true);
      localStorage.setItem("hasVisited", "true");
    }
  }, [t]);

  if (showSplash) {
    return (
      <SplashScreen
        onFinish={() => setShowSplash(false)} // Callback to hide splash
      />
    );
  }

  return (
    <Provider store={store}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Router>
        <AdminProvider>
          <Routes>
            {/* PUBLIC ROUTES */}
            <Route element={<PublicRoute />}>
              <Route
                path="/"
                element={
                  <FrontLayout>
                    <LandingPage />
                  </FrontLayout>
                }
              />
              <Route
                path="/terms-conditions"
                element={
                  <FrontLayout>
                    <TermsAndConditions />
                  </FrontLayout>
                }
              />

              <Route
                path="/privacy-policy"
                element={
                  <FrontLayout>
                    <PrivacyPolicy />
                  </FrontLayout>
                }
              />
              <Route
                path="/for-owner"
                element={
                  <FrontLayout>
                    <ForOwner />
                  </FrontLayout>
                }
              />
              <Route
                path="/for-customer"
                element={
                  <FrontLayout>
                    <ForCustomer />
                  </FrontLayout>
                }
              />
              <Route
                path="/about-us"
                element={
                  <FrontLayout>
                    <AboutUs />
                  </FrontLayout>
                }
              />
              <Route
                path="/contact-us"
                element={
                  <FrontLayout>
                    <ContactUs />
                  </FrontLayout>
                }
              />

              <Route path="/login" element={<Login />} />
              <Route path="/otp" element={<OTP />} />
              <Route path="/secure/login" element={<AdminLogin />} />
              <Route path="/customer-register" element={<Signup />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
            </Route>

            {/* ADMIN ROUTES */}
            <Route element={<PrivateRoute />}>
              <Route path="/store-add" element={<StoreFrontAdd />} />

              <Route element={<AdminLayout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route
                  path="/admin-update-profile"
                  element={<AdminProfile />}
                />
                <Route
                  path="/update-profile-store-owner"
                  element={<StoreOwnerProfile />}
                />
                <Route
                  path="/update-profile-customer"
                  element={<CustomerProfile />}
                />

                <Route path="/customers" element={<Customers />} />
                <Route path="/owner-store" element={<StoreOwner />} />
                <Route path="/owner-store-add" element={<AddStoreOwner />} />
                <Route
                  path="/owner-store-update/:uuid"
                  element={<AddStoreOwner />}
                />
                <Route path="/store" element={<Store />} />
                <Route path="/add-store" element={<AddStore />} />
                <Route path="/update-store/:uuid" element={<AddStore />} />
                <Route path="/category" element={<Category />} />
                <Route path="/units" element={<Units />} />
                <Route path="/products" element={<Product />} />
                <Route path="/products-add" element={<AddProduct />} />
                <Route path="/products-update/:uuid" element={<AddProduct />} />
                <Route path="/customer-store" element={<StorePOSView />} />
                <Route
                  path="/customer-store/inventory"
                  element={<InventoryView />}
                />
                <Route path="/success" element={<SuccessPage />} />

                <Route path="/order" element={<CustomerOrder />} />
                <Route
                  path="/order-details/:uuid"
                  element={<CustomerOrderDetails />}
                />

                <Route
                  path="/order-store-owner"
                  element={<StoreOwnerOrder />}
                />
                <Route
                  path="/pending-order/:uuid"
                  element={<PendingOrdersList />}
                />
                <Route
                  path="/all-store-owner-order-list"
                  element={<StoreOwnerOrderList />}
                />
                <Route
                  path="/all-store-owner-order-details/:uuid"
                  element={<StoreOwnerOrderDetails />}
                />
                <Route path="/daily-collection" element={<DailyCollection />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/wallet" element={<Wallet />} />
                <Route path="/wallet-details/:uuid" element={<StoreOwnerWalletDetails />} />
                <Route path="/wallet-store-details/:uuid" element={<WalletStoreDetails />} />


                <Route path="/product-chart" element={<ChartProduct />} />
                <Route path="/customer-report" element={<CustomerLedger />} />
                <Route path="/vendor" element={<VendorList />} />
                <Route path="/vendor-add" element={<AddVendor />} />
                <Route path="/vendor-update/:uuid" element={<AddVendor />} />
                <Route path="/vendor-update/:uuid" element={<AddVendor />} />
                <Route path="/stock-entry" element={<StockEntry />} />
                <Route path="/fav-product" element={<FavouriteProducts />} />
                <Route path="/customers-store" element={<StoreWiseCustomer />} />


                
               
              
              </Route>
            </Route>

            {/* 404 */}
            <Route path="*" element={<NoURLFoundPage />} />
          </Routes>
        </AdminProvider>
      </Router>
    </Provider>
  );
};

export default App;
